<div *ngIf="calloutContent?.outerTopContent" [innerHTML]="calloutContent?.outerTopContent"></div>
<div class="callout-outer-wrapper" [class]="calloutWrapperClass">
  <goab-callout
    [type]="calloutContent?.calloutVariant"
    [heading]="calloutContent?.headerText"
    [emphasis]="calloutContent?.emphasis ?? defaultEmphasis"
    [attr.data-cy]="'callout-' + calloutContent?.calloutVariant"
  >
    <div [innerHTML]="calloutContent?.bodyText"></div>
  </goab-callout>
</div>
<div *ngIf="calloutContent?.outerBottomContent" [innerHTML]="calloutContent?.outerBottomContent"></div>
